import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trRef", "requiredRowProps", "row", "rowId", "selectable"];
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultRowComponent = _ref => {
  let {
      trRef,
      requiredRowProps
      // These props are unused for the default implemenetation, but we dont want them being passed as a prop to the tr element
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("tr", Object.assign({}, requiredRowProps, {
    ref: trRef
  }, rest));
};